import '../pages.css';
import '../SenseShield.css';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import DateRangePicker, { computeRangeForPreset } from '../../components/Filters/DateRangePicker';
import FeedbackTable from '../../components/SenseShield/FeedbackTable';
import KnownIssuesPanel from '../../components/SenseShield/KnownIssuesPanel';

function FeedbackLoop() {
  const location = useLocation();

  // Links like /sense-shield/feedback-loop#known-issues (Summary's "Silent prompts" card) jump to that panel.
  useEffect(() => {
    if (!location.hash) return;
    document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [location.hash]);

  const [dateRange, setDateRange] = useState(() => ({ ...computeRangeForPreset('7d'), preset: '7d' }));
  const [loading, setLoading] = useState(false);

  const handleRefresh = useCallback(() => {
    setLoading(true);
    setDateRange((current) => ({ ...current }));
    setLoading(false);
  }, []);

  return (
    <div className="sense-shield-page">
      <div className="sense-shield-header">
        <h1>Feedback Loop</h1>
        <div className="sense-shield-filters">
          <DateRangePicker
            value={{ startDate: dateRange.startDate, endDate: dateRange.endDate }}
            preset={dateRange.preset}
            onChange={setDateRange}
            maxDate={new Date()}
            enabledPresets={['today', '7d', '14d', '30d', 'custom']}
          />
          <button className="sense-shield-refresh" onClick={handleRefresh} disabled={loading} type="button" aria-label="Refresh">
            <RefreshCw size={16} className={loading ? 'spinning' : ''} />
          </button>
        </div>
      </div>

      <div className="sense-shield-grid">
        <div className="sense-shield-panel sense-shield-panel-full">
          <FeedbackTable dateRange={dateRange} />
        </div>
        <div className="sense-shield-panel sense-shield-panel-full" id="known-issues">
          <KnownIssuesPanel />
        </div>
      </div>
    </div>
  );
}

export default FeedbackLoop;
